import axios from 'axios';

import routes from 'app/routes';

export default {
  update: (affiliateId, values, withFormData, successCallback, errorCallback) => {
    if (withFormData) {
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        formData.append(`affiliate[${key}]`, values[key] === null ? '' : values[key]);
      });

      axios
        .put(routes.api.affiliates.update(affiliateId), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((resp) => {
          successCallback(resp.data.data);
        }).catch((error) => {
          errorCallback(error.response.data);
        });
    } else {
      axios
        .put(
          routes.api.affiliates.update(affiliateId),
          { affiliate: values },
        )
        .then((resp) => {
          successCallback(resp.data.data);
        }).catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },
};
